/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


require('pace');
require('perfect-scrollbar');
require('@coreui/coreui-pro');
require('chart.js');


window.Vue = require('vue');
import Vuex from 'vuex'
Vue.use(Vuex)

window.moment = require('moment');
moment().format();

Vue.use(require('vue-moment'));

import {ServerTable, ClientTable, Event} from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bootstrap4', 'default');
Vue.use(ServerTable, {}, false, 'bootstrap4', );

import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
window.toastr = require('toastr')
Vue.use(VueToastr2)

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))



Vue.component('register-from-invite', require('./components/pageComponents/register.vue').default);

Vue.component('user-admin-main', require('./components/pageComponents/admin-user-main.vue').default);
Vue.component('product-main', require('./components/pageComponents/admin-product-main.vue').default);
Vue.component('product-single-main', require('./components/pageComponents/admin-product-single-main.vue').default);
Vue.component('item-single-main', require('./components/pageComponents/admin-item-single-main.vue').default);

Vue.component('user-dashboard-main', require('./components/pageComponents/user-dashboard-main.vue').default);
Vue.component('sm-dashboard-main', require('./components/pageComponents/sm-dashboard-main.vue').default);
Vue.component('admin-dashboard-main', require('./components/pageComponents/admin-dashboard-main.vue').default);

Vue.component('settings-main', require('./components/pageComponents/settings-main.vue').default);

Vue.component('admin-quote-main', require('./components/pageComponents/admin-quote-main.vue').default);

Vue.component('bm-dashboard-main', require('./components/pageComponents/bm-dashboard-main.vue').default);
Vue.component('bm-quote-main', require('./components/pageComponents/bm-quote-main.vue').default);

Vue.component('user-quote-main', require('./components/pageComponents/user-quote-main.vue').default);
Vue.component('user-contact-main', require('./components/pageComponents/user-contact-main.vue').default);
Vue.component('user-org-main', require('./components/pageComponents/user-org-main.vue').default);

Vue.component('org-detail-main', require('./components/pageComponents/org-detail-main.vue').default);
Vue.component('contact-detail-main', require('./components/pageComponents/contact-detail-main.vue').default);

Vue.component('settings-user-main', require('./components/pageComponents/settings-user-main.vue').default);


Vue.component('product-builder-main', require('./components/pageComponents/product-builder.vue').default);
Vue.component('quote-builder-main', require('./components/pageComponents/quote-builder.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

const app = new Vue({
    el: '#app',
});
